export const FETCH_ALL_DRIVER_SUCCESS = "FETCH_ALL_DRIVER_SUCCESS";
export const FETCH_ALL_DRIVER_ERROR = "FETCH_ALL_DRIVER_ERROR";

